import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import { SELECTION_TYPE } from 'site-modules/canvas/constants/canvas';
import { ThinkingText } from 'site-modules/canvas/components/chat-messages/ai-message/thinking-text/thinking-text';
import { CanvasLoader } from 'site-modules/canvas/components/canvas-loader/canvas-loader';
import { useStartMessages } from 'site-modules/canvas/hooks/use-start-messages';

import './start-screen-suggested-messages-desktop.scss';

const MESSAGES_NUMBER = 3;
const SUGGESTED_MESSAGES = [
  {
    icon: 'icon-star-empty',
    classes: 'bg-orange-90 overlay-white-40',
  },
  {
    icon: 'icon-search',
    classes: 'bg-green-90 overlay-white-30',
  },
  {
    icon: 'icon-money-bag',
    classes: 'bg-blue-90 overlay-white-40',
  },
];

export const StartScreenSuggestedMessages = memo(({ startMessage = null, className = null, onSubmit = noop }) => {
  const { isThinking, suggestedMessages } = useStartMessages(startMessage);

  const onMessageClick = useCallback(
    message => () => {
      onSubmit(message, { selectionType: SELECTION_TYPE.STARTER_MESSAGE });
    },
    [onSubmit]
  );

  return (
    <div className={classnames('start-screen-suggested-messages-desktop w-100 mx-auto pos-r mt-1_25', className)}>
      {isThinking && (
        <div className="d-flex align-items-center gap-0_75 text-cool-gray-10">
          <CanvasLoader />
          <ThinkingText />
        </div>
      )}
      {!isThinking && !!suggestedMessages && (
        <ul className={classnames('list-unstyled w-100 d-flex flex-column gap-1', className)}>
          {suggestedMessages
            ?.split(/\s*,\s*/)
            .slice(0, MESSAGES_NUMBER)
            .map((message, index) => (
              <li key={message}>
                <button
                  className={classnames(
                    'message-button gap-0_75 d-flex align-items-center justify-content-center text-transform-none text-start bg-transparent pe-1_75 text-cool-gray-30 border-0'
                  )}
                  onClick={onMessageClick(message)}
                >
                  <span
                    className={classnames(
                      'icon-container rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 test-class',
                      SUGGESTED_MESSAGES[index]?.classes
                    )}
                  >
                    <i
                      className={classnames('icon text-cool-gray-40 size-16', SUGGESTED_MESSAGES[index]?.icon)}
                      aria-hidden
                    />
                  </span>
                  {message}
                </button>
              </li>
            ))}
        </ul>
      )}
    </div>
  );
});

StartScreenSuggestedMessages.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  startMessage: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string,
    }),
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      userText: PropTypes.string,
      responsePromise: PropTypes.instanceOf(Promise),
      generatedResponseId: PropTypes.string,
      isCanceled: PropTypes.bool,
    }),
  ]),
};
